import React, { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material/styles';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import EditPromoCode from '../EditPromoCode';
import { format } from 'date-fns';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import { useRolePermissions, hasPermission } from '@projectK/context/RolesProvider';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 8,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },
  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },
  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },
    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
}));
const renderServiceTypeAndName = ({
  data,
  productElement,
  badgeElement,
  tournamentName,
}) => {
  let label = '-';
  let serviceName ='-';
  let alinText = 'center'

  if (data.product_id) {
    label = 'Product';
    serviceName = (<Box className='textwrap'>
            {productElement}- {badgeElement}
          </Box>)
          alinText= 'left';
  } else if (data.tournament_id) {
    label = 'Tournament';
    serviceName = (<Box className='textwrap'>{tournamentName}</Box>)
          alinText= 'left';
  }
  return (
    <>
      <StyledTableCell align={alinText}>{label}</StyledTableCell>
      <StyledTableCell align={alinText} style={{ textTransform: 'capitalize' }}>
        {serviceName}
      </StyledTableCell>
    </>
  );
};
const TableItem = ({
  data,
  onDelete,
  fetchData,
  verbiageSettings,
  tournamentId,
}) => {
  const { rolePermissions } = useRolePermissions();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
  };
  const handleDelete = (itemId) => {
    setItemToDelete(itemId);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    onDelete(itemToDelete);
    setDeleteConfirmationOpen(false);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };
  let productElement;
  if (data.product_name) {
    if (data.product_name.length > 20) {
      productElement = data.product_name;
    } else {
      productElement = data.product_name;
    }
  } else {
    productElement = '-';
  }
  let badgeElement;

  if (data.badge) {
    if (data.badge.length > 20) {
      badgeElement = data.badge;
    } else {
      badgeElement = data.badge;
    }
  } else {
    badgeElement = '-';
  }
  let tournamentName;
  if (data.tournament_id) {
    tournamentName = data.tournament_name;
  }
  const getPromoCodeStatusColor = () => {
    switch (data.is_active) {
      case 0: {
        return '#f84e4e91';
      }
      case 1: {
        return '#92f8d2';
      }
      default: {
        return '#E2A72E';
      }
    }
  };
  return (
    <TableRow key={data.promo_code_name} className='item-hover'>
      <StyledTableCell align='left' style={{ textTransform: 'capitalize' }}>
        <Box className='textwrap'>{data.promo_code_name}</Box>
      </StyledTableCell>
      <StyledTableCell align='left'>{data.code}</StyledTableCell>

      {!tournamentId &&
        renderServiceTypeAndName({
          badgeElement,
          data,
          productElement,
          tournamentName,
        })}
      <StyledTableCell align='left'>
        {data.start_date
          ? format(
              new Date(`${data.start_date.substring(0, 10)}T12:01:00`),
              'MMM dd, yyyy',
            )
          : '-'}
      </StyledTableCell>
      <StyledTableCell align='left'>
        {data.end_date
          ? format(
              new Date(`${data.end_date.substring(0, 10)}T12:01:00`),
              'MMM dd, yyyy',
            )
          : '-'}
      </StyledTableCell>

      <StyledTableCell align='left'>
        {data.discount_type.charAt(0).toUpperCase() +
          data.discount_type.slice(1)}
      </StyledTableCell>

      <StyledTableCell align='left'>
        {' '}
        {data.discount_type === 'fixed' && '$'}
        {data.discount_value}
        {data.discount_type === 'percentage' && '%'}
      </StyledTableCell>
      <StyledTableCell align='left' sx={{ minWidth: '110px' }}>
        <Box
          component='span'
          sx={{
            padding: '4px 10px',
            borderRadius: 30,
            display: 'inline-block',
            color: '#000000',
            backgroundColor: getPromoCodeStatusColor(),
          }}
        >
          {data.is_active ? 'Active' : 'Not Active'}
        </Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
           {hasPermission(rolePermissions, 'Company Settings - Promo Codes', 'update') && (
          <IconButton
            size='small'
            className='icon-btn icon-btn-eye'
            onClick={handleEditClick}
          >
            <AiOutlineEdit />
          </IconButton>
           )}
            {hasPermission(rolePermissions, 'Company Settings - Promo Codes', 'delete') && (
          <IconButton
            size='small'
            className='icon-btn'
            onClick={() => handleDelete(data.id)}
          >
            <AiOutlineDelete />
          </IconButton>
            )}
        </div>
      </StyledTableCell>
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleCancelDelete}
        maxWidth='xs'
      >
        <DialogTitle>
          <Typography variant='h4'>Confirm Deletion</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
            Are you sure you want to delete this promo code?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleConfirmDelete} color='primary'>
            Yes
          </Button>
          <Button onClick={handleCancelDelete} color='secondary'>
            No
          </Button>
        </DialogActions>
      </Dialog>
      {isEditModalOpen && (
        <EditPromoCode
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          promoCodeData={data}
          fetchData={fetchData}
          verbiageSettings={verbiageSettings}
          tournamentId={tournamentId}
        />
      )}
    </TableRow>
  );
};

export default TableItem;

TableItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  fetchData: PropTypes.func,
  verbiageSettings: PropTypes.object,
  tournamentId: PropTypes.number,
};
